export default __webpack_public_path__ + "static/flag-uk-wavy-892ffad7f05d4981f07cfee351437396.png";